// 1. Import your CONFIGURED api instance
import api from '@/plugins/axios';

// 2. Define the base path for this service
const SERVICE_PATH = '/symbol-service/api/v1/portfolios';

export default {
  getAllPortfolios(userEmail) {
    // 3. Use the full path
    return api.get(SERVICE_PATH, {
      params: {
        userId: userEmail
      }
    });
  },
  createPortfolio(portfolio) {
    return api.post(SERVICE_PATH, portfolio);
  },
  updatePortfolio(id, portfolio) {
    return api.put(`${SERVICE_PATH}/${id}`, portfolio);
  },
  deletePortfolio(id) {
    return api.delete(`${SERVICE_PATH}/${id}`);
  },
  getPortfolioCount(userEmail) {
    return api.get(`${SERVICE_PATH}/count`, {
      params: {
        userId: userEmail
      }
    });
  },
  getPortfolioAnalysis(id, period) {
    const params = {};
    if (period) params.period = period;
    return api.get(`${SERVICE_PATH}/${id}/analysis`, { params });
  },
};